class PdpProductCardCarousel extends HTMLElement {
  constructor() {
    super();

    window.loadSwiper.then(({ Swiper, Pagination }) => {
      const swiperParams = {
        modules: [Pagination],
        slidesPerView: "auto",
        navigation: {
          nextEl: this.querySelector(
            "[data-pdp-product-card-carousel-navigation-next]",
          ),
          prevEl: this.querySelector(
            "[data-pdp-product-card-carousel-navigation-previous]",
          ),
        },
        pagination: {
          clickable: true,
          enabled: true,
          el: ".swiper-pagination",
        },
        centerInsufficientSlides: true,
        breakpoints: {
          768: {
            pagination: {
              enabled: false,
            },
          },
          1024: {
            pagination: {
              enabled: false,
            },
          },
          1440: {
            pagination: {
              enabled: false,
            },
          },
        },
        on: {
          lock: () => {
            this.classList.add(
              "pdp-product-card-carousel__carousel-wrapper--locked",
            );
          },
          unlock: () => {
            this.classList.remove(
              "pdp-product-card-carousel__carousel-wrapper--locked",
            );
          },
        },
      };

      this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);
    });
  }

  connectedCallback() {}

  disconnectedCallback() {}
}

if (!customElements.get("pdp-product-card-carousel")) {
  customElements.define("pdp-product-card-carousel", PdpProductCardCarousel);
}
